import React,{Fragment,useContext, useEffect,useState} from 'react';
import {Link} from 'react-router-dom'; 
//Import Components
import loading_img from "../../../../images/profile/loading.gif";
import { GlobalSet } from '../../global/GlobalProvider';
import Coin_Listing from "../../../../images/icon/Coin_Listing.png";
import Arraws from "../../../../images/icon/arrr.png";
import Slider from "react-slick";
import axios from "axios";
import { Row, Col, Carousel,Accordion } from 'react-bootstrap'
import swal from "sweetalert";
const Home = () => {
  document.title = "Segma Home";
  const { BaseUrl } = GlobalSet();
  const [tradestatus, setTradeStatus] = useState([]);
  const [tracoinvalue, setCoinvalue] = useState([]);
  let incrementInterval;
  const [loading, setLoading] = useState(true);

   const [homedata, setHomeData] = useState([]);  
   const coin_wait = localStorage.getItem('coin_wait');
  /*.....product code........*/
  const data = {
       key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
       }
  const APiResponse = () => {
      axios.post('/home-data',data)
      .then(response=>{
         setHomeData(response.data.data_info)
         setTradeStatus(response.data.trade_status)
         setCoinvalue(response.data.coin_value)
         setLoading(false); 
       })
   .catch(error=>{
         console.log(error)
     });
   }
    useEffect(()=>{
   const interval = setInterval(
      (function callApi() {
        APiResponse();
        return callApi;
      })(),
      70000000
    );
    return () => clearInterval(interval);
    },[]);

return(
     <>
      <span className="d-xl-block">

        <div className="row m-1">
            <Fragment>

              <Col xl="12" className="p-0" >
                <div className="col-xl-12">
                  <div className="row mydivpadding">
                    <div className="row" style={{ margin: '0px auto', padding: '0px' }}>
                      <div className="col-xl-3 col-xxl-3 col-6 mb-4 nos-margin-bottom">
                        <div className="card booking" style={{border: '2px solid #002f6a', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'}}>
                          <div className="card-body p-4">
                            <div className="text-center">
                              <img 
                                src={BaseUrl+"public/basic_icon/asset_main_wallet.png"} 
                                alt="Main Wallet" 
                                width="60"
                                height="50"
                              />
                              <div className="mt-4">
                                <h2 className="mb-0 font-w600" style={{color: 'black', fontSize: '1.5rem'}}>${ homedata.balance }</h2>
                                <p className="mb-0 text-nowrap" style={{color: 'black', fontSize: '1rem'}}>Main Wallet</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-3 col-xxl-3 col-6 mb-4 nos-margin-bottom">
                        <div className="card booking" style={{border: '2px solid #002f6a', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'}}>
                          <div className="card-body p-4">
                            <div className="text-center">
                              <img 
                                src={BaseUrl+"public/basic_icon/asset_oin_comonity.png"} 
                                alt="Total Invest" 
                                width="60"
                                height="50"
                              />
                              <div className="mt-4">
                                <h2 className="mb-0 font-w600" style={{color: 'black', fontSize: '1.5rem'}}>
                                  ${ homedata.investing_wallet }  
                                </h2>
                                <p className="mb-0 text-nowrap" style={{color: 'black', fontSize: '1rem'}}>Total Invest</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      
                      <div className="col-xl-3 col-xxl-3 col-6 mb-4 nos-margin-bottom">
                        <div className="card booking" style={{border: '2px solid #002f6a', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'}}>
                          <div className="card-body p-4">
                            <div className="text-center">
                              <img 
                                src={BaseUrl + "public/basic_icon/asset_deposit_wallet.png"} 
                                alt="Deposit Icon" 
                                width="60"
                                height="50"
                              />
                              <div className="mt-4">
                                <h2 className="mb-0 font-w600" style={{color: 'black', fontSize: '1.5rem'}}>
                                  ${parseFloat(parseFloat(homedata.reserve_balance).toFixed(4))}
                                </h2>
                                <p className="mb-0 text-nowrap" style={{color: 'black', fontSize: '1rem'}}>Deposit Wallet</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-3 col-xxl-3 col-6 mb-4 nos-margin-bottom">
                        <div className="card booking" style={{border: '2px solid #002f6a', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'}}>
                          <div className="card-body p-4">
                            <div className="text-center">
                              <img 
                                src={Coin_Listing} 
                                alt="Count Node" 
                                width="60"
                                height="50"
                              />
                              <div className="mt-4">
                                <h2 className="mb-0 font-w600 text-white" style={{background: 'radial-gradient(#e23428, #002f6a)', color: 'white', textAlign: 'center', borderRadius: '20px', padding: '5px'}}>
                                  { homedata.investing_node }
                                </h2>
                                <p className="mb-0 text-nowrap text-dark" style={{fontSize: '1rem', color: '#ddd'}}>Count Node</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>


                    </div>
                     
                    <div className="row" style={{ margin: '0px auto', padding: '0px' }}>


                      <div className="col-xl-3 col-xxl-3 col-6 mb-4 nos-margin-bottom">
                        <div className="card booking" style={{border: '2px solid #002f6a', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'}}>
                          <div className="card-body p-4">
                            <div className="text-center">
                              <img 
                                src={BaseUrl+"public/basic_icon/asset_Total_Income.png"} 
                                alt="BRISE Reserve" 
                                width="60"
                                height="50"
                              />
                              <div className="mt-4">
                                <h2 className="mb-0 font-w600" style={{color: 'black', fontSize: '1.5rem'}}>
                                  { homedata.daily_return }
                                </h2>
                                <p className="mb-0 text-nowrap" style={{color: 'black', fontSize: '1rem'}}>Invest Return</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-3 col-xxl-3 col-6 mb-4 nos-margin-bottom">
                        <div className="card booking" style={{border: '2px solid #002f6a', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'}}>
                          <div className="card-body p-4">
                            <div className="text-center">
                              <img 
                                src={BaseUrl+"public/basic_icon/asset_ref_bounus.png"} 
                                alt="Refer Bonus" 
                                width="60"
                                height="50"
                              />
                              <div className="mt-4">
                                <h2 className="mb-0 font-w600" style={{color: 'black', fontSize: '1.5rem'}}>
                                  ${ homedata.refer_inc }
                                </h2>
                                <p className="mb-0 text-nowrap" style={{color: 'black', fontSize: '1rem'}}>Refer Bonus</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-3 col-xxl-3 col-6 mb-4 nos-margin-bottom">
                        <div className="card booking" style={{border: '2px solid #002f6a', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'}}>
                          <div className="card-body p-4">
                            <div className="text-center">
                              <img 
                                src={BaseUrl+"public/basic_icon/asset_total_deposit.png"} 
                                alt="BRISE Generation" 
                                width="60"
                                height="50"
                              />
                              <div className="mt-4">
                                <h2 className="mb-0 font-w600" style={{color: 'black', fontSize: '1.5rem'}}>
                                  { homedata.coin_gen }
                                </h2>
                                <p className="mb-0 text-nowrap" style={{color: 'black', fontSize: '1rem'}}>Invest Generation</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>                      
                      <div className="col-xl-3 col-xxl-3 col-6 mb-4 nos-margin-bottom">
                        <div className="card booking" style={{border: '2px solid #002f6a', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'}}>
                          <div className="card-body p-4">
                            <div className="text-center">
                              <img 
                                src={BaseUrl+"public/basic_icon/asset_XEXG_Genaration.png"} 
                                alt="BRISE Reserve" 
                                width="60"
                                height="50"
                              />
                              <div className="mt-4">
                                <h2 className="mb-0 font-w600" style={{color: 'black', fontSize: '1.5rem'}}>
                                  { homedata.coin_reserve }
                                </h2>
                                <p className="mb-0 text-nowrap" style={{color: 'black', fontSize: '1rem'}}>BRISE Reserve</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                     
                    <div className="row" style={{ margin: '0px auto', padding: '0px' }}>


                      <div className="col-xl-3 col-xxl-3 col-6 mb-4 nos-margin-bottom">
                        <div className="card booking" style={{border: '2px solid #002f6a', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'}}>
                          <div className="card-body p-4">
                            <div className="text-center">
                              <img 
                                src={BaseUrl+"public/basic_icon/asset_ref_bounus.png"} 
                                alt="Bord Earning" 
                                width="60"
                                height="50"
                              />
                              <div className="mt-4">
                                <h2 className="mb-0 font-w600" style={{color: 'black', fontSize: '1.5rem'}}>
                                  $ { homedata.bord_earning }
                                </h2>
                                <p className="mb-0 text-nowrap" style={{color: 'black', fontSize: '1rem'}}>Bord Earning</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    
                      <div className="col-xl-3 col-xxl-3 col-6 mb-4 nos-margin-bottom">
                        <div className="card booking" style={{border: '2px solid #002f6a', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'}}>
                          <div className="card-body p-4">
                            <div className="text-center">
                              <img 
                                src={BaseUrl+"public/basic_icon/asset_rank_income.png"} 
                                alt="IB Income" 
                                width="60"
                                height="50"
                              />
                              <div className="mt-4">
                                <h2 className="mb-0 font-w600" style={{color: 'black', fontSize: '1.5rem'}}>
                                  $ { homedata.leadership_bonus }
                                </h2>
                                <p className="mb-0 text-nowrap" style={{color: 'black', fontSize: '1rem'}}>IB Income</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>


                      <div className="col-xl-3 col-xxl-3 col-6 mb-4 nos-margin-bottom">
                        <div className="card booking" style={{border: '2px solid #002f6a', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'}}>
                          <div className="card-body p-4">
                            <div className="text-center">
                              <img 
                                src={BaseUrl+"public/basic_icon/asset_rank_income.png"} 
                                alt="Monthly Salary" 
                                width="60"
                                height="50"
                              />
                              <div className="mt-4">
                                <h2 className="mb-0 font-w600" style={{color: 'black', fontSize: '1.5rem'}}>
                                  ${ homedata.rank_income }
                                </h2>
                                <p className="mb-0 text-nowrap" style={{color: 'black', fontSize: '1rem'}}>Monthly Salary</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-3 col-xxl-3 col-6 mb-4 nos-margin-bottom">
                        <div className="card booking" style={{border: '2px solid #002f6a', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'}}>
                          <div className="card-body p-4">
                            <div className="text-center">
                              <img 
                                src={BaseUrl+"public/basic_icon/asset_total_deposit.png"} 
                                alt="Total Deposit Icon" 
                                width="60"
                                height="50"
                              />
                              <div className="mt-4">
                                <h2 className="mb-0 font-w600" style={{color: 'black', fontSize: '1.5rem'}}>
                                  ${ homedata.total_deposit }
                                </h2>
                                <p className="mb-0 text-nowrap" style={{color: 'black', fontSize: '1rem'}}>Total Deposit</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>                      
                    </div>

                    <div className="row" style={{ margin: '0px auto', padding: '0px' }}>


                      <div className="col-xl-3 col-xxl-3 col-6 mb-4 nos-margin-bottom">
                        <div className="card booking" style={{border: '2px solid #002f6a', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'}}>
                          <div className="card-body p-4">
                            <div className="text-center">
                              <img 
                                src={BaseUrl+"public/basic_icon/asset_Total_Income.png"} 
                                alt="Total Income Icon" 
                                width="60"
                                height="50"
                              />
                              <div className="mt-4">
                                <h2 className="mb-0 font-w600" style={{color: 'black', fontSize: '1.5rem'}}>
                                  ${ homedata.total_Income }
                                </h2>
                                <p className="mb-0 text-nowrap" style={{color: 'black', fontSize: '1rem'}}>Total Income</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-3 col-xxl-3 col-6 mb-4 nos-margin-bottom">
                      <div className="card booking" style={{border: '2px solid #002f6a', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'}}>
                        <div className="card-body p-4">
                          <div className="text-center">
                            <img 
                              src={BaseUrl+"public/basic_icon/asset_Total_Withdrawal.png"} 
                              alt="Total Withdrawal Icon" 
                              width="60"
                              height="50"
                            />
                            <div className="mt-4">
                              <h2 className="mb-0 font-w600" style={{color: 'black', fontSize: '1.5rem'}}>
                                ${ homedata.total_withdraw }
                              </h2>
                              <p className="mb-0 text-nowrap" style={{color: 'black', fontSize: '1rem'}}>Total Withdrawal</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    </div>
                  </div>
                </div>
             </Col>
          </Fragment>
        </div> 
      </span>
    </>
  )
}
export default Home;